import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full order-2 lg:order-1 flex justify-center">
            <div className="relative w-full max-w-[440px] aspect-[16/10] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20atmosphere%20with%20open%20manga%20comic%20books%20on%20wooden%20desk%20surrounded%20by%20soft%20ambient%20lighting%2C%20artistic%20lifestyle%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20comfortable%20home%20library%20setting%2C%20editorial%20style%2C%20shallow%20depth%20of%20field&width=880&height=550&seq=about-manga-platform&orientation=landscape"
                alt="43423漫画网 - 关于我们"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 w-full order-1 lg:order-2">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4 whitespace-nowrap">
              关于我们
            </span>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              {aboutData.title}
            </h2>
            <div className="space-y-4">
              {aboutData.paragraphs.map((p, i) => (
                <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
            <div className="flex flex-wrap gap-4 mt-8">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-primary-600"></i>
                </span>
                <span className="whitespace-nowrap">专业编辑团队</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-accent-600"></i>
                </span>
                <span className="whitespace-nowrap">成立于2019年</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-heart-line text-secondary-600"></i>
                </span>
                <span className="whitespace-nowrap">千万读者信赖</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}